import { render, staticRenderFns } from "./RegisterPointSearchConfirm.vue?vue&type=template&id=e98799f6&"
import script from "./RegisterPointSearchConfirm.vue?vue&type=script&lang=js&"
export * from "./RegisterPointSearchConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports